import moment from "moment-timezone";
import AppConfig from "../config/AppConfig";

export class DateUtils {

    static getDefaultOrUrlDateTimeParams(){
        const params = new URLSearchParams(window.location.search);

        let dateParam = null;
        let hourParam = null;

        for (const [key, value] of params.entries()) {
            const k = key.toLowerCase();
            if (k === "viewdate") {
                dateParam = value;
            }
            if (k === "viewhour") {
                hourParam = value;
            }
        }

        if (dateParam) {

            const acceptedFormats = [AppConfig.time.urlParamFormat, AppConfig.time.urlParamFormatOptional];

            const parsed = moment.tz(dateParam, acceptedFormats, AppConfig.time.displayTimezone);

            if (parsed.isValid()) {

                let hour = 0;

                if (hourParam !== null) {

                    const parsedHour = parseInt(hourParam, 10);

                    if (!isNaN(parsedHour) && parsedHour >= 0 && parsedHour <= 23) {
                        hour = parsedHour;
                    }
                }

                return parsed.hour(hour).minute(0).second(0).millisecond(0);
            }
        }

        return moment().tz(AppConfig.time.displayTimezone);

    }

    static getForecastStartCST() {

        const now = this.getDefaultOrUrlDateTimeParams();

        const todayOne = now.clone()
            .hour(13)
            .minute(0)
            .second(0)
            .millisecond(0);

        return now.isBefore(todayOne)
            ? now
            : now.add(1, "day");
    }

    static getTodayUtc(){
        const params = new URLSearchParams(window.location.search);
        const dateParam = params.get("viewDate");

        let utc;

        if (dateParam){
            utc = moment.tz(dateParam, AppConfig.time.urlParamFormat, AppConfig.time.displayTimezone).utc()
        }
        else {
            utc = moment.utc()
        }

        return utc
    }

    static getImpactStartCST() {

        const now = this.getForecastStartCST()

        const nowAtTen = now.clone()
            .hour(10)
            .minute(0)
            .second(0)
            .millisecond(0);

        const yesterdayAtTen = nowAtTen.clone().add(-1, "day");

        return yesterdayAtTen
    }


    static getStartSeason(){

        const currentYear = moment.tz(AppConfig.time.displayTimezone).year();

        return moment.tz({ year: currentYear, month: 2, day: 1 }, AppConfig.time.displayTimezone);
    }

    static getEndSeason(){

        const currentYear = moment.tz(AppConfig.time.displayTimezone).year();

        return moment.tz({ year: currentYear, month: 4, day: 1 }, AppConfig.time.displayTimezone);
    }

}
